import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  proposalMode: '',
  proposalListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  proposalDetails: {
    init: 0,
    initErr: [],
    menu: {},
    propInfo: {
      propNo: null,
      ipcNo: null,
      ipcSeqNo: null,
      polNo1: '',
      polNo2: '',
      polType: '',
      scheme: '',
      planNo: '',
      branch: '',
      agent: '',
      busSrc: '',
      name1: '',
      name2: '',
      name3: '',
      name4: '',
      addr1: '',
      addr2: '',
      addr3: '',
      addr4: '',
      postCode: '',
      telNo: '',
      mobileNo: '',
      faxNo: '',
      email: '',
      comDate: '',
      expDate: '',
      propDate: '',
      fininst: '',
      finBrn: '',
      finConPer: '',
      finTelNo: '',
      finFaxNo: '',
      siCurr: '',
      totSI: 0,
      grossAnnPrem: 0,
      paytMeth: '',
      crCdGIRO: '',
      acctName1: '',
      acctName2: '',
      freeInsRem: '',
      freeInsFr: '',
      freeInsTo: '',
      hdbReplCost: false,
      propStat: '',
      progId: '',
      comment1: '',
      comment2: '',
      typeProp: '',
      occpClass: '',
      area: '',
      gdsManuf: '',
      loc1: '',
      loc2: '',
      loc3: '',
      loc4: '',
      locPostCode: '',
      propType: '',
      propStatDesc: '',
      polTypeDesc: '',
      schbusClsDesc: '',
      planDesc: '',
      paytMethDesc: '',
      abbrevName: ''
    }
  },
  coverageDetails: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
